import { useEffect, useState } from "react";

function Counter({ target, suffix = "", value, label }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!target) return;

    let finalTarget = target;

    if (suffix === "K") finalTarget = target * 1000;
    if (suffix === "Mn+") finalTarget = target * 1000000;

    let start = 0;
    const duration = 2000;
    const increment = finalTarget / (duration / 20);

    const interval = setInterval(() => {
      start += increment;

      if (start >= finalTarget) {
        setCount(finalTarget);
        clearInterval(interval);
      } else {
        setCount(Math.ceil(start));
      }
    }, 20);

    return () => clearInterval(interval);
  }, [target, suffix]);

  const formatNumber = (num) => {
    switch (suffix) {
      case "K":
        return Math.floor(num / 1000) + "K";
      case "K+":
        return num + "K+";
      case "Mn+":
        return Math.floor(num / 1000000) + "Mn+";
      case "+":
        return num + "+";
      case "%":
        return num + "%";
      default:
        return num;
    }
  };

  let displayValue = value ? value : formatNumber(count);

  return (
    <div className="counter-container">
      <div className="counter">{displayValue}</div>
      <span>{label}</span>
    </div>
  );
}

export default Counter;